export const iconFontAwesomeMedicalHealthTeeth = (
	<i className="fa-solid fa-teeth"></i>
);
